import { createUseStyles } from 'react-jss';
import { ITheme } from '@quicktools/shared-components/styles/theme';
import { mediaQuery } from '@quicktools/shared-components/styles/helpers';

export default createUseStyles(
  ({ breakpoints }: ITheme) => ({
    '@global': {
      html: { height: '100%' },
      body: { backgroundColor: 'var(--x-bg-5)' },
      p: {
        maxWidth: 'calc(100% - 48px)',
      },
    },

    root: {
      height: '100%',
    },

    container: {
      padding: [24, 40],
      minHeight: 'calc(100% - 60px)',
    },
    breadcrumb: {
      marginBottom: 24,
    },
    main: {
      backgroundColor: 'var(--x-bg-1)',
      borderRadius: 16,
      fontWeight: 500,
      fontSize: 16,
      lineHeight: '24px',
      padding: 32,

      [mediaQuery(breakpoints.tablet)]: {
        padding: 24,
      },
    },
    layout: {
      display: 'grid',
      gap: 100,
      gridTemplateColumns: '1fr 195px',

      [mediaQuery(breakpoints.tablet)]: {
        gridTemplateColumns: '1fr',
        gap: 0,
        marginBottom: 48,
      },
    },
    title: {
      fontSize: 30,
      fontWeight: 700,
      lineHeight: '36px',
      marginBottom: 32,
    },
    subtitle: {
      color: 'var(--x-breadcrumb-last)',
      fontWeight: 500,
      fontSize: 20,
      lineHeight: '28px',
      marginBottom: 8,
    },
    paragraph: {
      marginBottom: 24,
    },
    boldHeading: {
      fontWeight: 700,
    },
    nameList: {
      fontWeight: 400,
      marginTop: 8,
      marginBottom: 42,
      paddingLeft: 16,

      [mediaQuery(breakpoints.tablet)]: {
        marginBottom: 32,
      },
    },
    noPadding: {
      padding: 0,
    },
    subtitleInline: {
      marginRight: 20,

      [mediaQuery(breakpoints.tablet)]: {
        alignSelf: 'flex-start',
        marginRight: 0,
        marginBottom: 20,
      },
    },
    inlineSection: {
      alignItems: 'center',
      display: 'flex',
      marginBottom: 50,

      [mediaQuery(breakpoints.tablet)]: {
        flexDirection: 'column',
        marginBottom: 32,
      },
    },
    copyContainer: {
      display: 'flex',
      alignSelf: 'flex-start',
    },
    glyphWithBackground: {
      alignItems: 'center',
      backgroundColor: 'var(--x-bg-6)',
      borderRadius: 8,
      display: 'flex',
      fontSize: 30,
      justifyContent: 'center',
      height: 48,
      marginRight: 8,
      width: 48,
    },
    copyButton: {
      backgroundColor: 'var(--x-accent-2-5)',
      border: 0,
      borderRadius: 8,
      cursor: 'pointer',
      color: 'var(--x-accent-2-1)',
      fontWeight: 600,
      height: 48,
      paddingInline: 24,
    },
    subtitlePadded: {
      marginBottom: 16,
    },
    imgContainer: {
      listStyleType: 'none',
      display: 'grid',
      gap: 26,
      gridTemplateColumns: '1fr 1fr',

      [mediaQuery(breakpoints.tablet)]: {
        gridTemplateColumns: '1fr',
        gap: 16,
      },
    },
    imgEntry: {
      alignItems: 'center',
      borderRadius: 16,
      boxShadow: '0px 1px 4px var(--x-shadow-card)',
      display: 'flex',
      justifyContent: 'space-between',
      padding: [12, 24],
      maxWidth: 'calc(100% - 32px)',
    },
    imgText: {
      color: 'var(--x-text-color-1)',
      fontSize: 20,
      fontWeight: 500,
    },
    img: {
      height: 100,
      width: 100,

      [mediaQuery(breakpoints.tablet)]: {
        height: 50,
        width: 50,
      },
    },
    note: {
      color: 'var(--x-breadcrumb-last)',
      fontSize: 14,
      lineHeight: '20px',
      marginTop: 16,
    },
    navButton: {
      borderRadius: 24,
      height: 48,
      marginBottom: 32,
      // maxWidth: 'calc(100% - 48px)',
    },
    navButtonIcon: {
      fill: 'var(--x-bg-1)',
    },
    categoryIcon: {
      fill: 'var(--x-accent-2-1)',
      marginRight: 8,
    },
    categoryText: {
      color: 'var(--x-accent-2-1)',
    },
    categoryContainer: {
      alignItems: 'center',
      display: 'flex',
      marginBottom: 24,
    },
    otherContainer: {
      listStyleType: 'none',
    },
    otherItem: {
      color: 'var(--x-breadcrumb-last)',
      marginBottom: 2,

      '&:hover': {
        color: 'var(--x-accent-2-1)',
      },
    },
    otherGlyph: {
      marginRight: 4,
    },
    tooltipContainer: {
      cursor: 'pointer',
      position: 'relative',
    },
    tooltip: {
      top: -42,
      display: 'none',
      position: 'absolute',
      left: 0,
      zIndex: 2,
    },
    tooltipVisible: {
      display: 'block',
    },
  }),
  {
    name: 'EmojiPage',
  },
);
